import React, { Component } from 'react';
import { connect } from 'react-redux';
import Actions_Wind from '~/Actions_Wind';
import permission from '~/skills/permission';
import {
  Select,
  MenuItem,
  TableRow,
  TableCell,
  TableHead,
  TableContainer,
  TableBody,
  Table,
} from '@material-ui/core';
import { ArrowBackIos, ArrowForwardIos, FirstPage, LastPage } from '@mui/icons-material';

import { T_TitleCell, T_Btn_Function, T_TableRow } from '~/components/TableItem';
import { S_Btn_Add } from '~/components/SearchItem';

import T_common from '~/components/TableItem/common';
import CheckDelete from '~/components/Dialog/CheckDelete';

class SubmarineList extends Component {
  state={
    keyword: '',

    per_page: 10,
    page: 1,

    sort: true,
    sort_field: 'upd_time',
    view_checkDelete: false,
    view_addAndEdit: false,
    mode_addAndEdit: '',
    currentId: '',
    currentAct: '',
  }

  componentDidMount () {
    // const { status, keyword, org_id } = this.state;
    // this.data = { status, keyword, org_id };
    this.refresh();
  }

  componentDidUpdate (preProps) {
    const { doRefresh: preDoRefresh = false } = preProps;
    const { doRefresh = false } = this.props;
    if (doRefresh && (doRefresh !== preDoRefresh)) {
      this.refresh();
    }
  }

  refresh=() => {
    const { getPPFanSubmarineList, handleSubmarineData } = this.props;
    const { page, per_page, sort, sort_field } = this.state;
    // const { status, keyword, org_id } = this.data;
    getPPFanSubmarineList({
      page,
      per_page,
      body: {
        // keyword,
        // org_id: org_id === '0' ? '' : org_id,
        sort: sort ? 'desc' : 'asc',
        sort_field,
      },
    });
    handleSubmarineData({ doRefresh: false });
  }

  search=() => this.setState({ page: 1 }, () => this.refresh());

  _click_search=() => {
    // const { status, keyword, org_id, sort, sort_field } = this.state;
    // this.data = { status, keyword, org_id, sort, sort_field };
    this.search();
  }

  _delete=(id, act) => this.setState({ currentId: id, currentAct: act, view_checkDelete: true })
  _close_view_checkDelete=() => {
    // this.refresh();
    this.setState({ currentId: '', currentAct: '', view_checkDelete: false });
  }

  // _add=() => this.setState({ view_addAndEdit: true, mode_addAndEdit: 'add' })
  _add=() => this.props.handleSubmarineData({ id: '', open: true, mode: 'add' })
  // _view=id => this.setState({ currentId: id, view_addAndEdit: true, mode_addAndEdit: 'view' })
  _view=id => this.props.handleSubmarineData({ id, open: true, mode: 'view' })
  // _edit=id => this.setState({ currentId: id, view_addAndEdit: true, mode_addAndEdit: 'edit' })
  _edit=id => this.props.handleSubmarineData({ id, open: true, mode: 'edit' })
  _close_view_addAndEdit=() => {
    this.refresh();
    this.setState({ currentId: '', view_addAndEdit: false, mode_addAndEdit: '' });
  }

  renderTableTitle=() => {
    const { sort, sort_field } = this.state;
    const onChangeSort = t => {
      this.setState({ sort_field: t, sort: sort_field === t ? !sort : false }, () => this.search());
    };
    const ary = [
      { name: '序號' },
      { name: '海纜段編號', id: 'cable_num' },
      { name: '施工進度' },
      { name: '抵台與否', id: 'is_tran_taiwan' },
      { name: '預計完成日' },
      { name: '實際完成日' },
      { name: '功能' },
    ];
    return (
      <TableHead>
        <TableRow style={{ height: 48 }}>
          {ary.map((o, i) => (
            <T_TitleCell
              key={i}
              text={o.name}
              arrow={!!o.id}
              bol={sort_field === o.id ? sort : true}
              onClick={() => onChangeSort(o.id)}
            />
          ))}
        </TableRow>
      </TableHead>
    );
  }

  renderTableBody=() => {
    const { PPFanSubmarineList, canEdit, canDel } = this.props;
    const { list = [], page = 0, total = 0, per_page = 0 } = PPFanSubmarineList;
    const cellStyle = { fontSize: 14 };
    let start = 0;
    if (page > 0) {
      start = (page - 1) * per_page + 1;
      if (start > total)start = 0;
    }

    return (
      <TableBody>
        {list.map((o, i) => (
          <T_TableRow key={i} backgroundColor= {i % 2 === 0 ? '#E0FDFF' : 'white'}>
            <TableCell align='center' style={cellStyle}>{i + start}</TableCell>
            <TableCell align='center' style={cellStyle}>{o.cable_num}</TableCell>
            <TableCell align='center' style={cellStyle} />
            <TableCell align='center' style={cellStyle}>{o.is_tran_taiwan}</TableCell>
            <TableCell align='center' style={cellStyle} />
            <TableCell align='center' style={cellStyle} />
            <TableCell style={{ width: 214 }}>
              <div style={{ width: '100%', display: 'flex', flexDirection: 'row' }}>
                <T_Btn_Function text='檢視' backgroundColor={T_common.type1} onClick={() => this._view(o.id)} />
                <T_Btn_Function text='編輯' backgroundColor={T_common.type2} onClick={() => this._edit(o.id)} style={{ marginLeft: 8, marginRight: 8 }} disabled={!canEdit} />
                <T_Btn_Function text='刪除' backgroundColor={T_common.type3} onClick={() => this._delete(o.id, o.cable_num)} disabled={!canDel} />
              </div>
            </TableCell>
          </T_TableRow>
        ))}
      </TableBody>
    );
  }

  renderTableBar=() => {
    const { PPFanSubmarineList = {} } = this.props;
    const { has_next = false, has_prev = false, page = 0, pages = 0, total = 0 } = PPFanSubmarineList;
    const { per_page, page: statePage } = this.state;
    const returnPages = () => {
      const array = [];
      for (let i = 1; i <= pages; i++) {
        array.push(i);
      }
      return array;
    };
    const returnPers = () => [10, 20, 30, 40];
    const canFirst = page > 1;
    const canLast = page < pages;
    return (
      <div style={{ height: 48, display: 'flex', alignItems: 'center', width: '98%', backgroundColor: 'white', borderBottomRightRadius: 8, borderBottomLeftRadius: 8, paddingTop: 6, paddingBottom: 6 }}>
        <div style={{ flex: 1 }} />
        <FirstPage style={{ height: 24, width: 24, color: canFirst ? 'black' : 'gray', cursor: canFirst ? 'pointer' : 'default' }} onClick={() => { if (canFirst) this.setState({ page: 1 }, () => this.refresh()); }} />
        <ArrowBackIos style={{ marginLeft: 3, marginRight: 5, height: 16, width: 16, color: has_prev ? 'black' : 'gray', cursor: has_prev ? 'pointer' : 'default' }} onClick={() => { if (has_prev) this.setState({ page: this.state.page - 1 }, () => this.refresh()); }} />
        <div style={{ fontSize: 14 }}>第</div>
        <Select
          style={{ backgroundColor: 'white', height: 36, fontSize: 16, letterSpacing: '0.15px', marginRight: 8, marginLeft: 8 }}
          variant="outlined"
          value={statePage}
          onChange={e => this.setState({ page: e.target.value }, () => { this.refresh(); })}
        >
          {returnPages().map((o, i) => <MenuItem key={i} value={o}>{o}</MenuItem>)}
        </Select>
        <div style={{ fontSize: 14, marginRight: 8 }}>{`/${pages} 頁，每頁`}</div>
        <Select
          style={{ backgroundColor: 'white', height: 36, fontSize: 16, letterSpacing: '0.15px' }}
          variant="outlined"
          value={per_page}
          onChange={e => this.setState({ per_page: e.target.value }, () => { this.search(); })}
        >
          {returnPers().map((o, i) => <MenuItem key={i} value={o}>{o}</MenuItem>)}
        </Select>
        <div style={{ fontSize: 14, marginLeft: 8 }}>{`筆，共${total}筆`}</div>
        <ArrowForwardIos style={{ marginLeft: 5, height: 16, width: 16, color: has_next ? 'black' : 'gray', cursor: has_next ? 'pointer' : 'default' }} onClick={() => { if (has_next) this.setState({ page: this.state.page + 1 }, () => this.refresh()); }} />
        <LastPage style={{ marginRight: 19, height: 24, width: 24, color: canLast ? 'black' : 'gray', cursor: canLast ? 'pointer' : 'default' }} onClick={() => { if (canLast) this.setState({ page: pages }, () => this.refresh()); }} />
        <div style={{ flex: 1 }} />
      </div>
    );
  }

  renderTable=() => {
    const { PPFanSubmarineList = {} } = this.props;
    const { list = [] } = PPFanSubmarineList;
    const haveData = list.length > 0;
    return (
      <TableContainer style={{ marginTop: 18, maxWidth: '98%' }}>
        <Table style={{ backgroundColor: 'white', borderTopLeftRadius: 8, borderTopRightRadius: 8 }}>
          {this.renderTableTitle()}
          {haveData && this.renderTableBody()}
        </Table>
      </TableContainer>
    );
  }

  render () {
    const { deletePPFanSubmarine, PPFanSubmarineList = {}, canAdd } = this.props;
    const { currentId, view_checkDelete, currentAct } = this.state;
    const { list = [] } = PPFanSubmarineList;
    const haveData = list.length > 0;
    return (
      <div style={{ width: '100%' }}>
        <div style={{ marginTop: 24, display: 'flex', alignItems: 'center' }}>
          <div style={{ color: '#064B6F', fontSize: 20, lineHeight: '24px', letterSpacing: '0.25%' }}>海纜清單</div>
          <S_Btn_Add onClick={this._add} style={{ marginLeft: 24 }} disabled={!canAdd} />
        </div>
        {this.renderTable()}
        {haveData && this.renderTableBar()}
        {!haveData && <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: 30 }}>尚無資料</div>}
        <CheckDelete
          open={view_checkDelete}
          text={`海纜段編號：${currentAct}`}
          onClose={this._close_view_checkDelete}
          search={this.search}
          resKey='DeletePPFanSubmarine'
          onDelete={() => { deletePPFanSubmarine(currentId); }}
        />
      </div>
    );
  }
}
const mapStateToProps = state => ({
  PPFanSubmarineList: state.data.PPFanSubmarineList,
  ...permission.returnPermission(state),
});
const mapDispatchToProps = dispatch => ({
  getPPFanSubmarineList: body => Actions_Wind.getPPFanSubmarineList(dispatch, body),
  deletePPFanSubmarine: id => Actions_Wind.deletePPFanSubmarine(dispatch, { id }),
});

export default connect(mapStateToProps, mapDispatchToProps)(SubmarineList);
